import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import {
  CountryDto,
  StateDto,
  LgaDto,
  CommunityDto,
  CurrencyDto,
  CorrespondenceActionPartyDto,
  CorrespondenceCompanyDto,
  CorrespondenceDepartmentFunctionDto,
  CorrespondenceIssuedCategoryDto,
  CorrespondenceRequestCategoryDto,
  CorrespondenceTeamDto,
} from '@cradua/data';

import { CommunityFacade } from '../../states/+community/community.facade';
import { CurrencyFacade } from '../../states/+currency/currency.facade';
import { LgaFacade } from '../../states/+lga/lga.facade';
import { StateFacade } from '../../states/+state/state.facade';
import { CountryFacade } from '../../states/+country/country.facade';
import { CorrespondenceActionPartyFacade } from '../../states/+action-party/action-party.facade';
import { CorrespondenceCompanyFacade } from '../../states/+company/company.facade';
import { CorrespondenceFunctionFacade } from '../../states/+function/function.facade';
import { CorrespondenceIssuedCategoryFacade } from '../../states/+issued-category/issued-category.facade';
import { CorrespondenceRequestCategoryFacade } from '../../states/+request-category/request-category.facade';
import { CorrespondenceTeamFacade } from '../../states/+team/team.facade';

@Component({
  selector: 'mrsoftapps-correspondence-reference',
  templateUrl: './correspondence-reference.component.html',
  styleUrls: ['./correspondence-reference.component.scss'],
})
export class CorrespondenceReferenceComponent implements OnInit {
  isLoadingCountry$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingCurrency$: Observable<any>;

  isLoadingActionParty$: Observable<any>;
  isLoadingCompany$: Observable<any>;
  isLoadingFunction$: Observable<any>;
  isLoadingIssuedCategory$: Observable<any>;
  isLoadingRequestCategory$: Observable<any>;
  isLoadingTeam$: Observable<any>;

  countries: any[];
  states: any[];
  lgas: any[];
  communities: any[];
  currencies: any[];
  actionParties: any[];
  companies: any[];
  functions: any[];
  issuedCategories: any[];
  requestCategories: any[];
  teams: any[];

  country$: Observable<CountryDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  community$: Observable<CommunityDto[]>;
  currency$: Observable<CurrencyDto[]>;

  actionParty$: Observable<CorrespondenceActionPartyDto[]>;
  company$: Observable<CorrespondenceCompanyDto[]>;
  function$: Observable<CorrespondenceDepartmentFunctionDto[]>;
  issuedCategory$: Observable<CorrespondenceIssuedCategoryDto[]>;
  requestCategory$: Observable<CorrespondenceRequestCategoryDto[]>;
  team$: Observable<CorrespondenceTeamDto[]>;

  data;
  task = 'load';
  sub: Subscription;
  items = [
    { id: 'actionParty', name: 'Action Party' },
    { id: 'company', name: 'Company' },
    { id: 'function', name: 'Department Function' },
    { id: 'issuedCategory', name: 'Issued Category' },
    { id: 'requestCategory', name: 'Request Category' },
    { id: 'team', name: 'Team' },
  ];

  constructor(
    private countryFacade: CountryFacade,
    private stateFacade: StateFacade,
    private lgaFacade: LgaFacade,
    private currencyFacade: CurrencyFacade,
    private communityFacade: CommunityFacade,
    private actionPartyFacade: CorrespondenceActionPartyFacade,
    private companyFacade: CorrespondenceCompanyFacade,
    private functionFacade: CorrespondenceFunctionFacade,
    private issuedCategoryFacade: CorrespondenceIssuedCategoryFacade,
    private requestCategoryFacade: CorrespondenceRequestCategoryFacade,
    private teamFacade: CorrespondenceTeamFacade
  ) {}

  ngOnInit() {
    this.isLoadingCountry$ = this.countryFacade.isLoadingCountry;
    this.isLoadingState$ = this.stateFacade.isLoadingState;
    this.isLoadingLga$ = this.lgaFacade.isLoadingLga;
    this.isLoadingCommunity$ = this.communityFacade.isLoadingCommunity;
    this.isLoadingCurrency$ = this.currencyFacade.isLoadingCurrency;

    this.isLoadingActionParty$ = this.actionPartyFacade.isLoadingCorrespondenceActionParty;
    this.isLoadingCompany$ = this.companyFacade.isLoadingCorrespondenceCompany;
    this.isLoadingFunction$ = this.functionFacade.isLoadingCorrespondenceFunction;
    this.isLoadingRequestCategory$ = this.requestCategoryFacade.isLoadingCorrespondenceRequestCategory;
    this.isLoadingIssuedCategory$ = this.issuedCategoryFacade.isLoadingCorrespondenceIssuedCategory;
    this.isLoadingTeam$ = this.teamFacade.isLoadingCorrespondenceTeam;

    this.country$ = this.countryFacade.loadCountry;
    this.state$ = this.stateFacade.loadState;
    this.lga$ = this.lgaFacade.loadLga;
    this.community$ = this.communityFacade.loadCommunity;
    this.currency$ = this.currencyFacade.loadCurrency;

    this.actionParty$ = this.actionPartyFacade.loadCorrespondenceActionParty;
    this.company$ = this.companyFacade.loadCorrespondenceCompany;
    this.function$ = this.functionFacade.loadCorrespondenceFunction;
    this.requestCategory$ = this.requestCategoryFacade.loadCorrespondenceRequestCategory;
    this.issuedCategory$ = this.issuedCategoryFacade.loadCorrespondenceIssuedCategory;
    this.team$ = this.teamFacade.loadCorrespondenceTeam;

    this.subscribeReference();
  }

  subscribeReference() {
    this.sub = this.country$.subscribe((data) => {
      this.countries = data.map((item) => {
        return {
          CountryName: item.CountryName,
          CountryCode: item.CountryCode,
          id: item.id,
        };
      });
    });

    this.sub = this.state$.subscribe((data) => {
      this.states = data.map((item) => {
        return {
          StateName: item.StateName,

          CountryId: item.CountryId,
          id: item.id,
        };
      });
    });

    this.sub = this.lga$.subscribe((data) => {
      this.lgas = data.map((item) => {
        return {
          LgaName: item.LgaName,

          StateId: item.StateId,
          id: item.id,
        };
      });
    });

    this.sub = this.community$.subscribe((data) => {
      this.communities = data.map((item) => {
        return {
          CommunityName: item.CommunityName,
          SerialNo: item.SerialNo,
          LgaId: item.LgaId,
          id: item.id,
        };
      });
    });

    this.sub = this.currency$.subscribe((data) => {
      this.currencies = data.map((item) => {
        return {
          CurrencyName: item.CurrencyName,
          CurrencyCode: item.CurrencyCode,
          id: item.id,
        };
      });
    });

    this.sub = this.actionParty$.subscribe((data) => {
      this.actionParties = data.map((item) => {
        return {
          CorrespondenceActionPartyName: item.CorrespondenceActionPartyName,
          CorrespondenceTeamId: item.CorrespondenceTeamId,
          id: item.id,
        };
      });
    });

    this.sub = this.company$.subscribe((data) => {
      this.companies = data.map((item) => {
        return {
          CorrespondenceCompanyName: item.CorrespondenceCompanyName,
          id: item.id,
        };
      });
    });

    this.sub = this.function$.subscribe((data) => {
      this.functions = data.map((item) => {
        return {
          CorrespondenceDepartmentFunctionName:
            item.CorrespondenceDepartmentFunctionName,
          CompanyId: item.CompanyId,
          id: item.id,
        };
      });
    });

    this.sub = this.requestCategory$.subscribe((data) => {
      this.requestCategories = data.map((item) => {
        return {
          CorrespondenceRequestCategoryName:
            item.CorrespondenceRequestCategoryName,
          AccountableFunctionId: item.AccountableFunctionId,
          id: item.id,
        };
      });
    });

    this.sub = this.issuedCategory$.subscribe((data) => {
      this.issuedCategories = data.map((item) => {
        return {
          IssuedCategoryName: item.IssuedCategoryName,
          id: item.id,
        };
      });
    });

    this.sub = this.team$.subscribe((data) => {
      this.teams = data.map((item) => {
        return {
          CorrespondenceTeamName: item.CorrespondenceTeamName,
          id: item.id,
        };
      });
    });
  }

  selectReference(event) {
    // console.log(event.value);
    this.data = event.value;
    this.task = 'reference';
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDelete(deletedValue: any[]) {
    if (deletedValue[0] === 'country') {
      deletedValue.shift();
      this.countryFacade.removeCountry(deletedValue);
    } else if (deletedValue[0] === 'state') {
      deletedValue.shift();
      this.stateFacade.removeState(deletedValue);
    } else if (deletedValue[0] === 'currency') {
      deletedValue.shift();
      this.currencyFacade.removeCurrency(deletedValue);
    } else if (deletedValue[0] === 'community') {
      deletedValue.shift();
      this.communityFacade.removeCommunity(deletedValue);
    } else if (deletedValue[0] === 'lga') {
      deletedValue.shift();
      this.lgaFacade.removeLga(deletedValue);
    } else if (deletedValue[0] === 'actionParty') {
      deletedValue.shift();
      this.actionPartyFacade.removeCorrespondenceActionParty(deletedValue);
    } else if (deletedValue[0] === 'company') {
      deletedValue.shift();
      this.companyFacade.removeCorrespondenceCompany(deletedValue);
    } else if (deletedValue[0] === 'function') {
      deletedValue.shift();
      this.functionFacade.removeCorrespondenceFunction(deletedValue);
    } else if (deletedValue[0] === 'requestCategory') {
      deletedValue.shift();
      this.requestCategoryFacade.removeCorrespondenceRequestCategory(
        deletedValue
      );
    } else if (deletedValue[0] === 'issuedCategory') {
      deletedValue.shift();
      this.issuedCategoryFacade.removeCorrespondenceIssuedCategory(
        deletedValue
      );
    } else if (deletedValue[0] === 'team') {
      deletedValue.shift();
      this.teamFacade.removeCorrespondenceTeam(deletedValue);
    }
  }

  // this method control both the create and update

  onSubmitProjectRef(formValue: any) {
    if (formValue.type === 'country') {
      event.preventDefault();
      const pullData = formValue.Countries;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCountry = [];

      // loop through the form data to check for update and create
      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCountry.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCountry.length !== 0) {
        this.countryFacade.addCountry(addAllCountry);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.countries, allUpdates);
      if (getChange) {
        // dispatch update data to the store
        this.countryFacade.updateCountry(allUpdates);
      }
    } else if (formValue.type === 'state') {
      event.preventDefault();
      const pullData = formValue.States;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllState = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllState.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllState.length !== 0) {
        this.stateFacade.addState(addAllState);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.states, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.stateFacade.updateState(allUpdates);
      }
    } else if (formValue.type === 'lga') {
      event.preventDefault();
      const pullData = formValue.Lgas;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllLga = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllLga.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllLga.length !== 0) {
        this.lgaFacade.addLga(addAllLga);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.lgas, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.lgaFacade.updateLga(allUpdates);
      }
    } else if (formValue.type === 'community') {
      event.preventDefault();
      const pullData = formValue.Communities;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCommunity = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCommunity.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCommunity.length !== 0) {
        this.communityFacade.addCommunity(addAllCommunity);
      }
      // console.log('communite ', this.communities, allUpdates);
      // check if there is any update on the object
      const getChange = this.getChanges(this.communities, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.communityFacade.updateCommunity(allUpdates);
      }
    } else if (formValue.type === 'currency') {
      event.preventDefault();
      const pullData = formValue.Currencies;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCurrencies = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCurrencies.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCurrencies.length !== 0) {
        this.currencyFacade.addCurrency(addAllCurrencies);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.currencies, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.currencyFacade.updateCurrency(allUpdates);
      }
    } else if (formValue.type === 'actionParty') {
      event.preventDefault();
      const pullData = formValue.ActionParties;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllActionParties = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllActionParties.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllActionParties.length !== 0) {
        this.actionPartyFacade.addCorrespondenceActionParty(
          addAllActionParties
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.actionParties, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.actionPartyFacade.updateCorrespondenceActionParty(allUpdates);
      }
    } else if (formValue.type === 'company') {
      event.preventDefault();
      const pullData = formValue.Companies;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCompanies = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCompanies.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCompanies.length !== 0) {
        this.companyFacade.addCorrespondenceCompany(addAllCompanies);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.companies, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.companyFacade.updateCorrespondenceCompany(allUpdates);
      }
    } else if (formValue.type === 'function') {
      event.preventDefault();
      const pullData = formValue.Functions;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllFunctions = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllFunctions.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllFunctions.length !== 0) {
        this.functionFacade.addCorrespondenceFunction(addAllFunctions);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.functions, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.functionFacade.updateCorrespondenceFunction(allUpdates);
      }
    } else if (formValue.type === 'requestCategory') {
      event.preventDefault();
      const pullData = formValue.RequestCategories;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllRequestCategories = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllRequestCategories.push(pullData[i]);
        }
      }
      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllRequestCategories.length !== 0) {
        this.requestCategoryFacade.addCorrespondenceRequestCategory(
          addAllRequestCategories
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.requestCategories, allUpdates);

      if (getChange) {
        // dispatch update data to the store
        this.requestCategoryFacade.updateCorrespondenceRequestCategory(
          allUpdates
        );
      }
    } else if (formValue.type === 'issuedCategory') {
      event.preventDefault();
      const pullData = formValue.IssuedCategories;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllIssuedCategories = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllIssuedCategories.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllIssuedCategories.length !== 0) {
        this.issuedCategoryFacade.addCorrespondenceIssuedCategory(
          addAllIssuedCategories
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.issuedCategories, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.issuedCategoryFacade.updateCorrespondenceIssuedCategory(
          allUpdates
        );
      }
    } else if (formValue.type === 'team') {
      event.preventDefault();
      const pullData = formValue.Teams;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllTeams = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllTeams.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllTeams.length !== 0) {
        this.teamFacade.addCorrespondenceTeam(addAllTeams);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.teams, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.teamFacade.updateCorrespondenceTeam(allUpdates);
      }
    }
  }

  getChanges(oldArray, newArray) {
    let changes, i, item, j, len;
    if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
      return false;
    }
    changes = [];
    for (i = j = 0, len = newArray.length; j < len; i = ++j) {
      item = newArray[i];
      if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
        changes.push(item);
      }
    }
    return changes;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
